import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Button, Spinner, Form } from "react-bootstrap";
import JoditEditor, { Jodit } from "jodit-react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as emailSlice from "../../../../redux/slices/emailSlice";

const SendEmail = () => {
  const editor = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [content, setContent] = useState(location.state?.message || "");
  const [subject, setSubject] = useState(location.state?.subject || "");
  const [recipient, setRecipient] = useState(location.state?.recipientEmail || "");
  const [isIndividualEmail, setIsIndividualEmail] = useState(!!location.state?.recipientEmail);
  const { loading } = useSelector((state) => state.emailSlice);
  const dispatch = useDispatch();

  useEffect(() => {
    setupImageUpload();
  }, []);
  
  const handleClear = () => {
    setRecipient("");
    setSubject("");
    setContent("");
  };

  const setupImageUpload = () => {
    Jodit.defaultOptions.controls.uploadImage = {
      name: "Upload Image",
      iconURL:
        "https://www.kindpng.com/picc/m/261-2619141_cloud-upload-icon-svg-hd.png",
      exec: async (editor) => {
        await handleImageUpload(editor);
      },
    };
  };

  const handleImageUpload = (editor) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("image", file);

        try {
          const response = await fetch("/api/upload", {
            method: "POST",
            body: formData,
          });
          const data = await response.json();
          if (data.url) {
            editor.selection.insertImage(data.url);
            toast.success("Image uploaded successfully!");
          }
        } catch (error) {
          toast.error("Image upload failed. Please try again.");
        }
      }
    };
  };

  const handleSendEmail = async () => {
    if (!subject || !content || (isIndividualEmail && !recipient)) {
      toast.error("All fields are required!");
      return;
    }

    const emailData = {
      email: recipient,
      subject,
      message: content,
      isIndividualEmail: isIndividualEmail
    };

    try {
      await dispatch(emailSlice.sendEmail(emailData, handleClear));
      toast.success("Email sent successfully!");
      if (isIndividualEmail) {
        navigate(-1); // Go back to contact details page
      }
    } catch (error) {
      toast.error("Failed to send email. Please try again.");
    }
  };

  return (
    <div className="send-email-container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5>Compose Email:</h5>
        {isIndividualEmail && (
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        )}
      </div>
      
      {loading && (
        <Spinner animation="border" className="d-block mx-auto my-3" />
      )}
      <Form>
        {isIndividualEmail && (
          <Form.Group controlId="emailRecipient" className="mb-3">
            <Form.Label>Recipient Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter recipient email"
              value={recipient}
              onChange={(e) => setRecipient(e.target.value)}
              required
              readOnly={isIndividualEmail}
            />
          </Form.Group>
        )}
        
        <Form.Group controlId="emailSubject" className="mb-3">
          <Form.Label>Subject</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter email subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group controlId="emailBody" className="mb-3">
          <Form.Label>Email Body</Form.Label>
          <JoditEditor
            ref={editor}
            value={content}
            config={{
              readonly: false,
              placeholder: "Type your email content here...",
            }}
            onBlur={(newContent) => setContent(newContent)}
          />
        </Form.Group>
        <Button
          style={{ backgroundColor: "#e8783d", border: "none" }}
          onClick={handleSendEmail}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Email"}
        </Button>
      </Form>
    </div>
  );
};

export default SendEmail;
